import type { SlackWorkspace } from './types';

export const getSlackWorkspaceUrl = (
  workspace?: SlackWorkspace | null
): string | null => {
  const subdomain = workspace?.domain ?? workspace?.name;

  if (!subdomain?.trim()) {
    return null;
  }

  const trimmed = subdomain.trim().toLowerCase();

  if (trimmed.endsWith('.slack.com')) {
    return trimmed;
  }

  return `${trimmed}.slack.com`;
};
